import { Outlet } from "react-router-dom";
import Backdrop from "./Backdrop";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { notificationActions } from "../store/notification-slice";
import AppNotification from "./AppNotification";


export default function GuestLayout() {

    let notification = useSelector(state => state.notification.notification)
    let dispatch = useDispatch()

    useEffect(() => {
        if (notification) {
            setTimeout(() => {
                dispatch(notificationActions.setNotification(null))
            }, 3000)
        }
    }, [notification])
    return <div className="bg-maryam" style={{ minHeight: '100vh', display: 'flex' }}>

        <main className="guest-layout" style={{ display: 'flex', flexDirection: 'column', width: '100%' }} >

            <Outlet />
        </main>

        <AppNotification notification={notification} />


        <Backdrop />
    </div>

}
